module.exports = __webpack_public_path__ + "img/icon_001.0ec4bdd3.png";